import type { Dispatch, SetStateAction } from 'react'

import { Alert, Input, Modal } from 'components'
import { Controller, useFormContext } from 'react-hook-form'

import * as S from './styles'

interface ModalConfirmationProps {
  isOpen: boolean
  isMultiple?: boolean
  isReject: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  handleContinue: () => void
  handleReturnAction: () => void
  hasAuthority: boolean
}

const ModalConfirmation = ({
  isOpen = false,
  isMultiple = false,
  setIsOpen,
  isReject,
  handleContinue,
  handleReturnAction,
  hasAuthority,
}: ModalConfirmationProps) => {
  const methods = useFormContext()
  const { control, watch } = methods

  const justification = watch('justification')
  return (
    <Modal
      buttonAction={handleContinue}
      buttonDisabled={isReject && justification === ''}
      buttonText={isReject ? 'Reprovar' : 'Aprovar'}
      open={isOpen}
      returnAction={handleReturnAction}
      returnText="Cancelar"
      setOpen={setIsOpen}
      showClose
      showReturn
      title={isReject ? 'Reprovar negociação' : 'Aprovar negociação'}
    >
      <S.Wrapper>
        {isReject ? (
          'Insira uma justificativa para a reprovação.'
        ) : !hasAuthority ? (
          `Tem certeza que deseja aprovar ${isMultiple ? 'estas negociações' : 'esta negociação'}?`
        ) : (
          <>
            <Alert fullWidth kind="warning" title="Fora da alçada" />
            Ao aprovar esta negociação, sua OV permanecerá
            <br /> pendente, aguardando a aprovação da diretoria.
          </>
        )}
        {isReject && (
          <S.FieldWrapper>
            <Controller
              control={control}
              name="justification"
              render={({ field: { name, value, onChange } }) => (
                <Input
                  height={90}
                  label="Descrição"
                  maxLength={255}
                  name={name}
                  onChange={onChange}
                  placeholder="Descreva aqui a justificativa"
                  required
                  rows={3}
                  value={value}
                />
              )}
            />
          </S.FieldWrapper>
        )}
      </S.Wrapper>
    </Modal>
  )
}

export default ModalConfirmation
